import { IndexBreedsScreen, IndexBreedsScreenProps } from 'shared/screens/breeds/index-breeds';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { shouldNoIndexBreedsFilter } from 'shared/state/breeds-filter';

export default function IndexBreeds(props: IndexBreedsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) => {
        const pageSeo = seo
          .setTitle(t('breeds.index_breeds.title'))
          .setDescription(t('breeds.index_breeds.description'))
          .setPagination(props.initialBreeds);

        return shouldNoIndexBreedsFilter(props.initialFilter) ? pageSeo.setNoIndex() : pageSeo;
      }}
    >
      <IndexBreedsScreen
        {...props}
        title={t('breeds.index_breeds.title')}
        description={t('breeds.index_breeds.description')}
      />
    </Page>
  );
}

export const getServerSideProps = withServerProps(IndexBreedsScreen.pageBuilder);
